export default "__VITE_ASSET__DuM5FvJQ__"